// Admin server categories. "Other" is every country that is not the UK or the USA.
export const REGIONS = [{ key: 'all', label: 'All' }, { key: 'uk', label: 'UK' }, { key: 'usa', label: 'USA' }, { key: 'other', label: 'Other' }];

export const regionOf = (country) => {
    const c = String(country || '').trim().toLowerCase();
    if (['united kingdom', 'uk', 'great britain', 'england'].includes(c)) return 'uk';
    if (['united states', 'usa', 'us', 'united states of america'].includes(c)) return 'usa';
    return 'other';
};

export const countRegions = (rows, countryOf) => {
    const counts = { all: 0, uk: 0, usa: 0, other: 0 };
    for (const row of rows || []) { counts[regionOf(countryOf(row))]++; counts.all++; }
    return counts;
};
